import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#243E81",
    viewBox: "0 0 24 25",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M12.747 16.36h.84q.2 0 .2.2v.653q0 .2-.2.2h-3.174q-.2 0-.2-.2v-.653q0-.2.2-.2h.84v-4.454h-.72q-.2 0-.2-.2v-.693q0-.2.2-.2h2.014q.2 0 .2.2zm-1.614-6.734a.95.95 0 0 1-.253-.68q0-.413.253-.68a.9.9 0 0 1 .694-.28q.44 0 .693.28a.92.92 0 0 1 .267.68.92.92 0 0 1-.267.68q-.267.267-.707.267-.425 0-.68-.267"/> <path fill-rule="evenodd" d="M12 21.2a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17m0 1.5c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10" clip-rule="evenodd"/>' }
  })
);